// extracted by mini-css-extract-plugin
module.exports = {"contactContainer":"ContactBox_contactContainer__1bpI3","contentBox":"ContactBox_contentBox__38CA9","contactLink":"ContactBox_contactLink__1dEFP"};